// Place any jQuery/helper plugins in here.
(function (targetWidth) {
    var deviceWidth = screen.width;
    var ratio = deviceWidth / targetWidth;
    var viewport = document.querySelector('meta[name="viewport"]');
    if (ratio < 1) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=' + ratio + ', minimum-scale=' + ratio + ', maximum-scale=' + ratio + ', user-scalable=yes');
    }
})(375);

$(function () {
    // 錨點
    $('[data-anchor-btn]').on('click.anchor', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $(`#${$(this).data('anchor-btn')}`).offset().top
        }, 300);
        $('body').removeClass('-menuOpen');
    });

    // 選單
    $('[data-burger]').on('click.burger', function () {
        $('body').toggleClass('-menuOpen');
    });

    // 收合
    $('[data-collapse-action]').on('click', function (e) {
        e.preventDefault();
        const isMobile = window.matchMedia('(max-width: 1023px)').matches;
        if (!isMobile) return;
        $(this).closest('[data-collapse]').toggleClass('is-open').find('[data-collapse-content]').slideToggle();
    });
});